import React from 'react';
import ReactPaginate from 'react-paginate';
import './pagination.scss';
export var Pagination = function (props) {
    var handlePageClick = props.handlePageClick, containerClassName = props.containerClassName, subContainerClassName = props.subContainerClassName, previousLabel = props.previousLabel, nextLabel = props.nextLabel, pageCount = props.pageCount, pageNumber = props.pageNumber, pagePer = props.pagePer, pageSumLength = props.pageSumLength, pageLength = props.pageLength, offset = props.offset, handlePaperSelect = props.handlePaperSelect;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "pagination" },
            React.createElement("div", { className: "container-pagination-right" },
                React.createElement("select", { className: "form-control btn", value: pagePer, onChange: handlePaperSelect },
                    React.createElement("option", { value: 10 }, "10"),
                    React.createElement("option", { value: 30 }, "30"),
                    React.createElement("option", { value: 50 }, "50"),
                    React.createElement("option", { value: 100 }, "100")),
                React.createElement(ReactPaginate, { previousLabel: previousLabel ? previousLabel : "Previous", previousLinkClassName: "previous-pagination", nextLabel: "Next ", nextLinkClassName: "next-pagination", breakLabel: "...", breakClassName: "break-me", pageCount: pageCount, marginPagesDisplayed: 2, pageRangeDisplayed: 5, forcePage: pageNumber, onPageChange: handlePageClick, containerClassName: "container-pagination " + containerClassName, 
                    //   subContainerClassName={`sub-container-pagination ${subContainerClassName}`}
                    activeClassName: "active" })),
            React.createElement("p", null,
                "Showing ",
                (offset * pageNumber) + 1,
                " to ",
                (offset * pageNumber) + pageLength,
                " of ",
                pageSumLength,
                " entries"))));
};
